__turbopack_context__.v({
  "description": "index-module__m5OrDG__description",
  "footer": "index-module__m5OrDG__footer",
  "title": "index-module__m5OrDG__title",
  "wrapper": "index-module__m5OrDG__wrapper",
});
